import { Box } from '@mui/material';
import { ResponsivePie } from '@nivo/pie';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function PortfolioDonut({ data }) {
    const { theme } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const filtered = data.filter(d => d.id !== 'Unknown');
    if (filtered.length === 0) return null;
    const total = filtered.reduce((acc, d) => acc + (d.value || 0), 0);

    return (
        <ChartSection
            id="portfolio-donut"
            title="What does Congress's portfolio look like?"
            subtitle="Sector allocation by dollar volume — if all congressional trades were one portfolio"
        >
            <Box sx={{ height: 420 }}>
                <ResponsivePie
                    data={filtered}
                    animate={false}
                    margin={{ top: 20, right: 180, bottom: 20, left: 20 }}
                    innerRadius={0.55}
                    padAngle={1}
                    cornerRadius={3}
                    activeOuterRadiusOffset={6}
                    colors={{ scheme: 'purple_blue' }}
                    borderWidth={1}
                    borderColor="rgba(255,255,255,0.1)"
                    arcLinkLabelsTextColor="#9ca3af"
                    arcLinkLabelsColor={{ from: 'color' }}
                    arcLinkLabelsSkipAngle={12}
                    arcLabelsSkipAngle={15}
                    arcLabelsTextColor="#ffffff"
                    valueFormat={v => '$' + v.toFixed(1) + 'M'}
                    legends={[
                        {
                            anchor: 'right',
                            direction: 'column',
                            translateX: 150,
                            itemWidth: 150,
                            itemHeight: 20,
                            symbolSize: 10,
                            symbolShape: 'circle',
                            itemTextColor: '#9ca3af',
                        },
                    ]}
                    tooltip={({ datum }) => (
                        <ChartTooltip
                            title={datum.id}
                            rows={[
                                {
                                    label: 'Volume',
                                    value: '$' + datum.value.toFixed(1) + 'M',
                                    color: datum.color,
                                },
                                {
                                    label: 'Share',
                                    value:
                                        total > 0
                                            ? ((datum.value / total) * 100).toFixed(1) + '%'
                                            : '—',
                                },
                            ]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
